import BaseService from './../base'

class LoginService extends BaseService {
  // 登录接口
  async loginApi(postData) {
    return await this.post('/admin/login', postData);
  }
  // 微信扫码登录
  async scanLogin() {
    return await this.get('/admin/scan_login')
  }
  // 微信扫码获取用户信息
  async scanLoginInform(data) {
    return await this.get('/admin/scan_login/inform', data)
  }
  // 注册账号
  async register(postData) {
    return await this.post('/admin/register', postData)
  }
  // 根据手机号码获取短信验证码
  async getMobileCode(mobile) {
    return await this.get(`/admin/register/code`, mobile)
  }
  // 注册补充信息
  async sponsorInformation(postData) {
    return await this.post('/admin/sponsor_information', postData)
  }
}

export default new LoginService();